import React, { type FC, useMemo, useState } from 'react';

import { Flex, useDisclosure } from '@chakra-ui/react';

import { Viewport } from '@/components/Viewport';
import { AdminNavBar } from '@/features/admin';
import {
  AdminLayoutContext,
  type AdminLayoutContextNavDisplayed,
  type AdminLayoutContextValue,
} from '@/features/admin/AdminLayoutContext';

export const AdminLayout: FC<
  React.PropsWithChildren<{
    navHidden?: boolean;
  }>
> = ({ navHidden = false, children }) => {
  const [navDisplayed, setNavDisplayed] =
    useState<AdminLayoutContextNavDisplayed>(!navHidden);
  const navDrawer = useDisclosure();

  const providerValue = useMemo(
    () =>
      ({
        navDisplayed,
        setNavDisplayed,
        navDrawer,
      }) satisfies AdminLayoutContextValue,
    [navDisplayed, navDrawer]
  );

  return (
    <AdminLayoutContext.Provider value={providerValue}>
      <Viewport bgGradient="linear(to-b, brand.25, gray.50)">
        {!!navDisplayed && <AdminNavBar display="block" />}
        <Flex flex="1" direction="column">
          {children}
        </Flex>
      </Viewport>
    </AdminLayoutContext.Provider>
  );
};
